import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { PropTypes } from 'prop-types';
import { Link } from "react-router-dom";
import { Collapse } from 'reactstrap';
import * as Tools from "../../helpers/Tools";
import * as msgs from "../../constants/textConstants";
import { Typography, LinkText, Divider, Icon } from "../ecosystem/";
import AppointmentOverviewItem from "./AppointmentOverviewItem";

const AppointmentOverview = ({ recipientsPhase, locationPhase, insurancePhase, vaccinesPhase, eligibilityPhase, datePhase,
    confirmPhase, selectedUsers, serviceLocation, selectedVaccines, selectedDateTime, cities, screenBreakPoint }) => {

    const [toggleContent, settoggleContent] = useState(false);
    const apptOverviewLabel = "Appointment overview";
    const accordionOverview = !(screenBreakPoint === msgs.XXL_DESKTOP) ? true : false;
    const isMobile = !(screenBreakPoint === msgs.XL_DESKTOP && screenBreakPoint === msgs.XXL_DESKTOP) ? true : false;

    useEffect(() => {
        if (document) {
            document.body.style.overflow = toggleContent ? "hidden" : "";
        }
        return () => {
            if (document) document.body.style.overflow = "";
        };
    }, [toggleContent]);

    const sectionActive = (section) => {
        switch (section) {
            case 'location':
                return true
            case 'recipients':
                if (recipientsPhase || insurancePhase || vaccinesPhase || eligibilityPhase || datePhase || confirmPhase) {
                    return true
                }
                return false;
            case 'insurances':
                if (insurancePhase || vaccinesPhase || eligibilityPhase || datePhase || confirmPhase) {
                    return true
                }
                return false;
            case 'vaccines':
                if (vaccinesPhase || eligibilityPhase || datePhase || confirmPhase) {
                    return true
                }
                return false;
            case 'eligibility':
                if (eligibilityPhase || datePhase || confirmPhase) {
                    return true
                }
                return false;
            case 'date':
                if (datePhase || confirmPhase) {
                    return true
                }
                return false;
            case 'confirmDetail':
                if (confirmPhase) {
                    return true;
                }
                return false
            default:
                return false
        }
    }

    const getStepStatus = (sectionLabel, sectionAfter) => {
        if (sectionActive(sectionAfter)) {
            return 'completed';
        } else if (sectionActive(sectionLabel)) {
            return 'active';
        } else {
            return 'todo';
        }
    }

    const formatCity = (cityName) => {
        if (cityName && cities) {
            let formattedCity = cities.find(c => c.value === cityName.toLowerCase())
            if (formattedCity) return formattedCity.label;
        }
        return cityName;
    }

    const getSelectedVaccines = () => {
        const allSelectedVaccines = {};

        selectedVaccines?.forEach(item => {
            item.vaccines_groups.forEach(group => {
                group.vaccines.forEach(vax => {
                    if (vax.isChecked) {
                        let user = selectedUsers?.find(user => user.mrn === item.mrn)
                        if (allSelectedVaccines[vax.display_name] === undefined) {
                            allSelectedVaccines[vax.display_name] = { count: 1, users: [user.firstName] };
                        }
                        else {
                            allSelectedVaccines[vax.display_name].count = allSelectedVaccines[vax.display_name].count + 1;
                            allSelectedVaccines[vax.display_name].users.push(user.firstName);
                        }
                    }
                })
            })
        });
        return allSelectedVaccines;
    }

    const displaySelectedVaccines = () => {
        const arr = getSelectedVaccines();
        return Object.keys(arr).map((key) => (
            <div key={`vaccines-${key}`}>
                {arr[key].count}x {key} ({arr[key].users.join(", ")})
            </div>
        ))
    }

    /*const displayApptDateTime1 = () => {
         const out = { date: '', day: '', monthName: '', year: '', time: '' };
         const selected = new Date(selectedDateTime);
 
         console.log("In inhome overview ", //Tools.getCentralDateWithFormat(selectedDateTime, "LT"),
             //Tools.getCentralDateWithFormat(selectedDateTime, "MMM DD"),
            // Tools.getCentralDateWithFormat(selectedDateTime, 'z'),
             Tools.getCentralDateWithFormat(selectedDateTime, 'dddd MMMM Do YYYY, h:mm:ss A')
         );
 
         let weekday = new Array(7);
         weekday[0] = "Sunday";
         weekday[1] = "Monday";
         weekday[2] = "Tuesday";
         weekday[3] = "Wednesday";
         weekday[4] = "Thursday";
         weekday[5] = "Friday";
         weekday[6] = "Saturday";
         out.day = weekday[selected.getDay()];
         out.date = selected.getDate();
         out.year = selected.getFullYear();
         out.time = Tools.timeformat(selected)
         out.monthName = selected.toLocaleString('default', { month: 'long' });
         return (
             <>
                 <span>{out.day}, {out.monthName} {out.date}, {out.year}</span><br />
                 <span>{out.time}</span>
             </>
         )
     }*/

    const displayApptDateTime = () => {

        const selected = new Date(selectedDateTime);
        const displayApptDateTime = Tools.getCentralDateWithFormat(selectedDateTime, 'dddd MMMM Do YYYY, h:mm A');

        // console.log("In inhome overview ", //Tools.getCentralDateWithFormat(selectedDateTime, "LT"),
        //Tools.getCentralDateWithFormat(selectedDateTime, "MMM DD"),
        // Tools.getCentralDateWithFormat(selectedDateTime, 'z'),
        //Tools.getCentralDateWithFormat(selectedDateTime, 'dddd MMMM Do YYYY, h:mm:ss A')
        //);
        return (
            <>
                {displayApptDateTime}
            </>
        );
    }

    const appointmentSection = () => {
        return (
            <>
                <div className="info-wrapper">
                    <AppointmentOverviewItem
                        label={"Location & Contact"}
                        status={getStepStatus('location', "recipients")}
                        url={"/inhomeschedules"}
                        isMobile={isMobile}
                    >
                        {sectionActive('recipients') && <>
                            <div>
                                {serviceLocation?.address1}{serviceLocation?.address2 ? `, ${serviceLocation.address2}` : ''}
                            </div>
                            <div>
                                {formatCity(serviceLocation?.city)}, {serviceLocation?.state} {serviceLocation?.zipCode}
                            </div>
                            <div>
                                {serviceLocation?.email}
                            </div>
                            <div>
                                {serviceLocation?.mobilePhone}
                            </div>
                        </>}
                    </AppointmentOverviewItem>
                </div>
                <div className="info-wrapper">
                    <AppointmentOverviewItem
                        label={"Recipients"}
                        status={getStepStatus('recipients', "insurances")}
                        url={"/inhomeschedule/s3"}
                        isMobile={isMobile}
                    >
                        {(sectionActive('insurances') && !sectionActive('eligibility')) &&
                            <>{selectedUsers && selectedUsers.map((u) => {
                            return <div key={u.mrn}>
                                {u.patientName} ({u.dob})
                            </div>
                            })}
                        </>}

                        {/*if past vaccine selection screen, filter out selected users with no selected vaccines*/}
                        {sectionActive('eligibility') && <>

                            {selectedVaccines &&
                                selectedVaccines?.reduce((acc, u) => {
                                    if (u.vaccines_groups?.find(vg => vg.vaccines?.find(vax => vax.isChecked))) {
                                        acc.push(
                                            <div key={u.mrn}>
                                                {u.patientName} ({u.dob})
                                            </div>
                                        )
                                    }
                                    return acc;
                                }, [])}
                        </>
                        }
                    </AppointmentOverviewItem>
                </div>
              

                <div className="info-wrapper">
                    <AppointmentOverviewItem
                        label={"Insurance"}
                        status={getStepStatus('insurances', "vaccines")}
                        url={"/inhomeschedule/s31"}
                        isMobile={isMobile}
                    >
                        {sectionActive('vaccines') && <>
                            {selectedUsers?.map((u) => {
                                return (<div key={u.mrn}>
                                    {u.patientName} ({u.insurance})
                                </div>)
                            })
                            }
                        </>}
                    </AppointmentOverviewItem>
                </div>
                <div className="info-wrapper">
                    <AppointmentOverviewItem
                        label={"Vaccines"}
                        status={getStepStatus('vaccines', "eligibility")}
                        url={"/inhomeschedule/s4"}
                        isMobile={isMobile}
                    >
                        {sectionActive('eligibility') && <>
                            {displaySelectedVaccines()}
                        </>
                        }
                    </AppointmentOverviewItem>
                </div>
                <div className="info-wrapper">
                    <AppointmentOverviewItem
                        label={"Eligibility/Screening"}
                        status={getStepStatus('eligibility', "date")}
                        url={"/inhomeschedule/s5"}
                        isMobile={isMobile}
                    >
                    </AppointmentOverviewItem>
                </div>
                <div className="info-wrapper">
                    <AppointmentOverviewItem
                        label={"Date & Time"}
                        status={getStepStatus('date', "confirmDetail")}
                        url={"/inhomeschedule/s6"}
                        isMobile={isMobile}
                    >
                        {sectionActive('confirmDetail') && <>
                            {displayApptDateTime()}
                        </>
                        }
                    </AppointmentOverviewItem>
                </div>
            </>
        )
    }
    let mobileborderWidth = '0%';
    if (recipientsPhase) {
        mobileborderWidth = '16.5%';
    } else if (locationPhase) {
        mobileborderWidth = '33%';
    } else if (vaccinesPhase) {
        mobileborderWidth = '49.5%';
    } else if (eligibilityPhase) {
        mobileborderWidth = '66%';
    } else if (datePhase) {
        mobileborderWidth = '82.5%';
    }

    return <div className={`appointment-overview-container ${(accordionOverview && toggleContent) ? 'appointment-overview-container-expand' : ''}`}>
        <div className="text-container">
            {!accordionOverview
                ? <>
                    { /*Desktop only*/}
                    <div className="heading-wrapper">
                        <Typography
                            type="heading-05"
                        >
                            {apptOverviewLabel}
                        </Typography>
                        <Divider mTop="small" mBottom="none" mLeft="none" mRight="none" />
                    </div>
                    <div>
                        {appointmentSection()}
                    </div>
                </>
                : <>
                    { /*mobile and tablet only*/}
                    {/* <div className="mobile-border-section-grey"></div>
                    <div className="mobile-border-section" style={{ width: mobileborderWidth }}></div>*/}
                    <div className="heading-wrapper" onClick={() => settoggleContent(!toggleContent)}>
                        <Typography type="body-03" color="$color-primary-a2" bold tag="div" textAlign="center">
                            {recipientsPhase && <span className="heading">Recipients</span>}
                            {locationPhase && <span className="heading">Location & Contact</span>}
                            {insurancePhase && <span className="heading">Insurance</span>}
                            {vaccinesPhase && <span className="heading">Vaccines</span>}
                            {eligibilityPhase && <span className="heading">Eligibility</span>}
                            {datePhase && <span className="heading">Date & Time</span>}
                            {confirmPhase && <span className="heading">Confirm</span>}
                        </Typography>
                        <Icon name={toggleContent ? "chevron-up" : "chevron-down"}
                            size="medium" />
                    </div>
                    <Collapse isOpen={toggleContent}>
                        <div className="appointment-overview__content">
                            <div className="appointment-overview__label">
                                <Typography
                                    type="heading-03"
                                >
                                    {apptOverviewLabel}
                                </Typography>
                                <Divider mTop="small" mBottom="none" mLeft="none" mRight="none" />
                            </div>
                            {appointmentSection()}
                        </div>
                    </Collapse>
                </>
            }
        </div>
    </div>
}

AppointmentOverview.defaultProps = {
    recipientsPhase: false,
    locationPhase: false,
    insurancePhase: false,
    vaccinesPhase: false,
    eligibilityPhase: false,
    datePhase: false

}

AppointmentOverview.propTypes = {
    recipientsPhase: PropTypes.bool,
    locationPhase: PropTypes.bool,
    insurancePhase: PropTypes.bool,
    vaccinesPhase: PropTypes.bool,
    eligibilityPhase: PropTypes.bool,
    datePhase: PropTypes.bool,
}

const mapStateToProps = state => {
    return {
        profileList: state.memberships.profileList,
        selectedUsers: state.inHome.selectedUsers || [],
        serviceLocation: state.inHome.serviceLocationContactInfo,
        selectedVaccines: state.inHome.selectedVaccines || [],
        selectedDateTime: state.inHome.selectedDateTime,
        cities: state.inHome.prefilledCities,
        screenBreakPoint: state.common.screenBreakPoint,
    }
}

export default connect(mapStateToProps, null)(AppointmentOverview);